import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('student');
  const [isRegister, setIsRegister] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const endpoint = isRegister ? '/api/auth/register' : '/api/auth/login';
      const payload = isRegister ? { username, password, role } : { username, password };
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}${endpoint}`, payload);
      if (!isRegister) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('role', response.data.role);
        navigate(`/${response.data.role}`);
      } else {
        alert('Registered successfully');
        setIsRegister(false);
      }
    } catch (error) {
      alert('Error: ' + error.response.data.message);
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <h2>{isRegister ? 'Register' : 'Login'}</h2>

          {/* Auto-login buttons for demo accounts */}
          {!isRegister && (
            <div className="mb-4">
              <h5>Quick Login (Demo Accounts)</h5>
              <div className="d-grid gap-2">
                <button
                  className="btn btn-outline-primary"
                  onClick={() => {
                    setUsername('teacher');
                    setPassword('password123');
                    setTimeout(() => document.querySelector('form').dispatchEvent(new Event('submit')), 100);
                  }}
                >
                  👨‍🏫 Login as Teacher
                </button>
                <button
                  className="btn btn-outline-success"
                  onClick={() => {
                    setUsername('student');
                    setPassword('password123');
                    setTimeout(() => document.querySelector('form').dispatchEvent(new Event('submit')), 100);
                  }}
                >
                  👨‍🎓 Login as Student
                </button>
                <button
                  className="btn btn-outline-warning"
                  onClick={() => {
                    setUsername('admin');
                    setPassword('password123');
                    setTimeout(() => document.querySelector('form').dispatchEvent(new Event('submit')), 100);
                  }}
                >
                  👑 Login as Admin
                </button>
              </div>
              <hr />
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Username</label>
              <input type="text" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} required />
            </div>
            <div className="mb-3">
              <label>Password</label>
              <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            {isRegister && (
              <div className="mb-3">
                <label>Role</label>
                <select className="form-control" value={role} onChange={(e) => setRole(e.target.value)}>
                  <option value="student">Student</option>
                  <option value="teacher">Teacher</option>
                  <option value="admin">Admin</option>
                </select>
              </div>
            )}
            <button type="submit" className="btn btn-primary">{isRegister ? 'Register' : 'Login'}</button>
          </form>
          <button className="btn btn-link" onClick={() => setIsRegister(!isRegister)}>
            {isRegister ? 'Already have an account? Login' : 'Need an account? Register'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;